import { POST } from "@store/methods";

// login user
export const loginUser = (data) => {
  return POST("/login", data);
};

// logout user
export const logoutUser = (data) => {
  return POST("/logout", data);
};

// forgot password
export const forgotPassword = (data) => {
  return POST("/send-password-reset-link", data);
};

//reset password
export const resetPassword = (data) => {
  return POST("/reset-password", data);
};

export const changePassword = (data) => {
  return POST("/change-password", data);
};